export interface IHoliday {
  name: string
  description: string
  country: {
    id: string
    name: string
  }
  date: {
    iso: string
    datetime: {
      year: number
      month: number
      day: number
    }
  }
  type: string[]
  urlid: string
  locations: string
  states: string
}

export const holidays: IHoliday[] = [
  {
    name: "New Year's Day",
    description:
      'New Year’s Day is the first day of the year, or January 1, in the Gregorian calendar.',
    country: {
      id: 'cz',
      name: 'Czechia',
    },
    date: {
      iso: '2023-01-01',
      datetime: {
        year: 2023,
        month: 1,
        day: 1,
      },
    },
    type: ['National holiday'],
    urlid: 'czech/new-year-day',
    locations: 'All',
    states: 'All',
  },
  {
    name: 'Restoration of the Czech Independence Day',
    description:
      'Restoration of the Czech Independence Day is a national holiday in Czechia',
    country: {
      id: 'cz',
      name: 'Czechia',
    },
    date: {
      iso: '2023-01-01',
      datetime: {
        year: 2023,
        month: 1,
        day: 1,
      },
    },
    type: ['National holiday'],
    urlid: 'czech/restoration-of-the-czech-independence-day',
    locations: 'All',
    states: 'All',
  },
  {
    name: 'Good Friday',
    description:
      'Good Friday is a global Christian observance two days before Easter Sunday.',
    country: {
      id: 'cz',
      name: 'Czechia',
    },
    date: {
      iso: '2023-04-07',
      datetime: {
        year: 2023,
        month: 4,
        day: 7,
      },
    },
    type: ['National holiday'],
    urlid: 'czech/good-friday',
    locations: 'All',
    states: 'All',
  },
  {
    name: 'Easter Monday',
    description: 'Easter Monday is the day after Easter Sunday.',
    country: {
      id: 'cz',
      name: 'Czechia',
    },
    date: {
      iso: '2023-04-10',
      datetime: {
        year: 2023,
        month: 4,
        day: 10,
      },
    },
    type: ['National holiday'],
    urlid: 'czech/easter-monday',
    locations: 'All',
    states: 'All',
  },
  {
    name: 'Labor Day / May Day',
    description:
      "Labor Day, International Workers' Day, and May Day, is a day off for workers in many countries around the world.",
    country: {
      id: 'cz',
      name: 'Czechia',
    },
    date: {
      iso: '2023-05-01',
      datetime: {
        year: 2023,
        month: 5,
        day: 1,
      },
    },
    type: ['National holiday'],
    urlid: 'czech/labor-day',
    locations: 'All',
    states: 'All',
  },
  {
    name: 'Victory in Europe Day',
    description: 'Victory in Europe Day is a national holiday in Czechia',
    country: {
      id: 'cz',
      name: 'Czechia',
    },
    date: {
      iso: '2023-05-08',
      datetime: {
        year: 2023,
        month: 5,
        day: 8,
      },
    },
    type: ['National holiday'],
    urlid: 'czech/victory-in-europe-day',
    locations: 'All',
    states: 'All',
  },
  {
    name: 'Day of Saints Cyril and Methodius',
    description:
      'Day of Saints Cyril and Methodius is a national holiday in Czechia',
    country: {
      id: 'cz',
      name: 'Czechia',
    },
    date: {
      iso: '2023-07-05',
      datetime: {
        year: 2023,
        month: 7,
        day: 5,
      },
    },
    type: ['National holiday'],
    urlid: 'czech/saints-cyril-and-methodius',
    locations: 'All',
    states: 'All',
  },
  {
    name: 'Jan Hus Day',
    description: 'Jan Hus Day is a national holiday in Czechia',
    country: {
      id: 'cz',
      name: 'Czechia',
    },
    date: {
      iso: '2023-07-06',
      datetime: {
        year: 2023,
        month: 7,
        day: 6,
      },
    },
    type: ['National holiday'],
    urlid: 'czech/jan-hus-day',
    locations: 'All',
    states: 'All',
  },
  {
    name: 'St. Wenceslas Day',
    description: 'St. Wenceslas Day is a national holiday in Czechia',
    country: {
      id: 'cz',
      name: 'Czechia',
    },
    date: {
      iso: '2023-09-28',
      datetime: {
        year: 2023,
        month: 9,
        day: 28,
      },
    },
    type: ['National holiday'],
    urlid: 'czech/st-wenceslas-day',
    locations: 'All',
    states: 'All',
  },
  {
    name: 'Independent Czechoslovak State Day',
    description:
      'Independent Czechoslovak State Day is a national holiday in Czechia',
    country: {
      id: 'cz',
      name: 'Czechia',
    },
    date: {
      iso: '2023-10-28',
      datetime: {
        year: 2023,
        month: 10,
        day: 28,
      },
    },
    type: ['National holiday'],
    urlid: 'czech/independent-czechoslovak-state-day',
    locations: 'All',
    states: 'All',
  },
  {
    name: 'Struggle for Freedom and Democracy Day',
    description:
      'Struggle for Freedom and Democracy Day is a national holiday in Czechia',
    country: {
      id: 'cz',
      name: 'Czechia',
    },
    date: {
      iso: '2023-11-17',
      datetime: {
        year: 2023,
        month: 11,
        day: 17,
      },
    },
    type: ['National holiday'],
    urlid: 'czech/struggle-for-freedom-and-democracy-day',
    locations: 'All',
    states: 'All',
  },
  {
    name: 'Christmas Eve',
    description:
      'Christmas Eve is the day before Christmas Day and falls on December 24 in the Gregorian calendar.',
    country: {
      id: 'cz',
      name: 'Czechia',
    },
    date: {
      iso: '2023-12-24',
      datetime: {
        year: 2023,
        month: 12,
        day: 24,
      },
    },
    type: ['National holiday'],
    urlid: 'czech/christmas-eve',
    locations: 'All',
    states: 'All',
  },
  {
    name: 'Christmas Day',
    description:
      'Christmas Day is one of the biggest Christian celebrations and falls on December 25 in the Gregorian calendar.',
    country: {
      id: 'cz',
      name: 'Czechia',
    },
    date: {
      iso: '2023-12-25',
      datetime: {
        year: 2023,
        month: 12,
        day: 25,
      },
    },
    type: ['National holiday'],
    urlid: 'czech/christmas-day',
    locations: 'All',
    states: 'All',
  },
  {
    name: "St. Stephen's Day",
    description: "St. Stephen's Day is a national holiday in Czechia",
    country: {
      id: 'cz',
      name: 'Czechia',
    },
    date: {
      iso: '2023-12-26',
      datetime: {
        year: 2023,
        month: 12,
        day: 26,
      },
    },
    type: ['National holiday'],
    urlid: 'czech/st-stephen-day',
    locations: 'All',
    states: 'All',
  },
]
